import axios from "axios";
import router from "./router";
import Element from "element-ui"

// let protocol = window.location.protocol; //协议
// let host = window.location.host; //主机
// let reg = /^localhost+/;
// if(reg.test(host)) {
//    //若本地项目调试使用
// 	axios.defaults.baseURL = 'http://localhost:8081';
// } else {
// 	//动态请求地址协议主机
// 	axios.defaults.baseURL = protocol + "//" + host  +":8081";
// }

 axios.defaults.baseURL = config.serviceUrl
// axios.defaults.baseURL = "http://localhost:8082"
// axios.defaults.baseURL = "http://121.37.234.11:8081"
// axios.defaults.baseURL = "http://192.168.5.26:8081"

const request = axios.create({
	timeout: 60000,
	headers: {
		'Content-Type': "application/json; charset=utf-8"
	}
})

request.interceptors.request.use(config => {
	config.headers['Authorization'] = localStorage.getItem("token")
	return config
})

request.interceptors.response.use(
	response => {

		console.log("response ->" + response)

		let res = response.data

		if (res.code === 200) {
			return response
		} else {
			Element.Message.error(!res.msg ? '系统异常' : res.msg)
			return Promise.reject(response.data.msg)
		}
	},
	error => {

		console.log(error)

		if (error.response.data) {
			error.massage = error.response.data.msg
		}

		if (error.response.status === 401) {
			router.push("/login")
		}

		// if (error.response.status === 400) {
		// 	router.push("/login")
		// }

		Element.Message.error(error.massage, {duration: 3000})
		return Promise.reject(error)
	}
)

export default request